import {Backbone, $} from 'backboneAdapter';
import i18n from 'l10n';
import * as moment from 'moment';
import dhtmlx from 'dhtmlxAdapter';

async function handleSuccessfulLogin(response) {
    console.info(response);
    const storedEditorConfig = localStorage.getItem("savedEditorConfig");
    if (storedEditorConfig) {
        localStorage.removeItem("savedEditorConfig");
        const response = await $.post('/CampaignCloud/mosaico/import/', JSON.parse(storedEditorConfig));
        if (response.data && response.data.redirectUrl)
            window.open(response.data.redirectUrl);
    }

    const storedRef = sessionStorage.getItem("referrer");
    window.open(`${storedRef ? storedRef : 'Dashboard.htm'}`, '_self');
}

const BaseOuterView = Backbone.View.extend({

    async bootstrap(options) {
        this.isPostpaid = options.isPostpaid;
        try {
            this.fbApi = await options.fbApiFuture;
        } catch (e) {
            this.fbApi = null;
        }
    },
    //this doesn't belong here, just piggybacking for the shake of convenience
    notifyNavigator(e) {
        e.preventDefault();
        this.trigger("navigation", $(e.currentTarget).data("navigation"));
    },
    async getLoginAjax(url, formValues) {
        const response = await $.ajaxDefaultQ({
            url: url,
            type: 'POST',
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-TZ-Offset', -(new Date()).getTimezoneOffset());
                xhr.setRequestHeader('X-TZ-Name', moment.tz.guess());
                xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
            },
            dataType: "json",
            data: formValues
        });
        handleSuccessfulLogin();
        return response;
    },
    async facebookAuth() {
        try {
            let {status, authResponse} = await this.fbApi.login({scope: 'public_profile,email'});
            if (status !== "connected")
                throw "Could not get Graph access_token";
            let tldFbConnect = await $.postDefaultQ("/CampaignCloud/oauthClient/facebook/connect", authResponse);
            const {outcome, data} = tldFbConnect;
            if (outcome === "error") {
                throw {
                    message: "Could not retrieve necessary profile info from Graph",
                    data: data
                };
            } else if (data.action === "login") {
                window.open("Dashboard.htm", "_self");
            } else if (data.action === "confirm") {
                this.trigger("navigation", "ThirdParty/Facebook/Confirm");
            }
        } catch (fbLoginException) {
            console.error(fbLoginException);
        }
    },
    async initiateAndHandleLogin(url, formValues) {
        try {
            displaySpinner(true);
            await this.getLoginAjax(url, formValues);
        } catch (e) {
            console.info(e);
            displaySpinner(false);

            if (e.status === 401) {
                var message;
                var obj = JSON.parse(e.responseText);
                var cause = obj.cause;
                if (obj.message === 'no_totp_code') {
                    dhtmlx.alert(i18n.t("totp.specifyTotpCode"));
                } else if (cause === 'needConfirmation') {
                    message = i18n.t("login.needconfirmation");
                    const loginConfirmationResult = await dhtmlx.confirm({
                        type: "confirm",
                        text: message,
                        ok: i18n.t("message.yes"),
                        cancel: i18n.t("message.no"),
                    });
                    const {username, password} = formValues;
                    if (loginConfirmationResult) {

                        try {
                            const confirmationResend = await $.ajaxDefaultQ({
                                type: "POST",
                                url: '/CampaignCloud/Registration/ResendConfirmationMail',
                                dataType: "json",
                                data: {
                                    username,
                                    password,
                                    lng: i18n.language
                                }
                            });

                            let alertMsg = confirmationResend.status === 'success' ?
                                "register.checkresentmail"
                                : "register.erroronserver";
                            dhtmlx.alert(i18n.t(alertMsg));
                        } catch (e) {
                            dhtmlx.alert(i18n.t("register.internalerror"));
                        }
                    }
                } else {
                    if (cause === 'badCredentials') {
                        message = i18n.t("login.badcredentials");
                    } else if (cause === 'accountLocked') {
                        message = i18n.t("login.accountlocked");
                    } else if (cause === 'accountExpired') {
                        message = i18n.t("login.accountexpired");
                    } else if (cause === 'credentialsExpired') {
                        message = i18n.t("login.credentialsexpired");
                    } else {
                        message = i18n.t("login.notexists");
                    }
                    await dhtmlx.alert(message);
                    $("#usernameInput").val('');
                    $("#passwordInput").val('');
                }
            } else if (e.status === 403) {
                try {
                    const response = await $.ajaxDefaultQ({
                        url: '/CampaignCloud/RememberMeController/ping',
                        type: 'GET',
                        dataType: "json"
                    });

                    if (response.status === 'success') {
                        handleSuccessfulLogin();
                    }
                } catch (e) {
                    window.csrf = e.getResponseHeader('X-CSRF-TOKEN');
                    await this.getLoginAjax(url, formValues);
                }
            }
        }
    }
});

function displaySpinner(status){
    if(status){
        $('#login-spinner').css("display", "inherit");
    }else{
        $('#login-spinner').css("display", "none");
    }
}

function disableLoginForm(status){
    $('#usernameInput').prop("disabled", status);
    $('#passwordInput').prop("disabled", status);
    $('#login-button').prop("disabled", status);
}


export {BaseOuterView as default};